import React from 'react';

const Hebergem = () => {
  const publicUrl = process.env.PUBLIC_URL + '/';

  return (
    <div className="Visa mg-top-120 container">
      <div className="row">
        <div className="col-12">
          <p>
            Notre engagement envers votre confort et votre satisfaction commence
            dès que vous réservez votre séjour avec nous. Nous nous efforçons de
            vous offrir un service d&apos;hébergement exceptionnel dans nos
            hôtels, en veillant à ce que chaque détail soit pris en compte pour
            répondre à vos besoins et à vos attentes. Notre équipe dédiée est à
            votre disposition pour vous offrir un accueil chaleureux et pour
            vous assister tout au long de votre séjour. De la réservation
            initiale à votre départ, nous nous engageons à rendre votre
            expérience aussi agréable et sans souci que possible, afin que vous
            puissiez vous concentrer pleinement sur votre séjour parmi nous.
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-4 col-lg-3 image-block mb-4 mt-4">
          <img
            src={publicUrl + 'assets/img/team/1.webp'}
            alt="Hôtel 1"
            className="img-fluid"
          />
        </div>
        <div className="col-12 col-md-4 col-lg-3 image-block mb-4 mt-4">
          <img
            src={publicUrl + 'assets/img/team/2.webp'}
            alt="Hôtel 2"
            className="img-fluid"
          />
        </div>
        <div className="col-12 col-md-4 col-lg-3 image-block mb-4 mt-4">
          <img
            src={publicUrl + 'assets/img/team/3.webp'}
            alt="Hôtel 3"
            className="img-fluid"
          />
        </div>
        <div className="col-12 col-md-4 col-lg-3 image-block mb-4 mt-4">
          <img
            src={publicUrl + 'assets/img/team/4.webp'}
            alt="Hôtel 4"
            className="img-fluid"
          />
        </div>
        <div className="col-12 col-md-4 col-lg-3 image-block mb-4 mt-4">
          <img
            src={publicUrl + 'assets/img/team/5.webp'}
            alt="Hôtel 5"
            className="img-fluid"
          />
        </div>
      </div>
    </div>
  );
};
export default Hebergem;
